module.exports = __webpack_public_path__ + "img/pantalla-4-4.b70a6a13.png";